var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"fill":"none","height":"24","viewBox":"0 0 24 24","width":"24","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"m12.9188 16.6735 5.7818-5.4679 1.2994 1.2288-8 7.5656-8-7.5656 1.29936-1.2288 5.78184 5.4679v-12.6735h1.8376z","fill":_vm.fill}})])
}
var staticRenderFns = []

export { render, staticRenderFns }